"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _decorators = require("decorators");

var _class, _descriptor, _descriptor2, _temp;

var EventInfoBar = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(EventInfoBar, _Component);

  function EventInfoBar() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, EventInfoBar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(EventInfoBar)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "startTime", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "endTime", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    _this.state = {
      now: Date.now()
    };
    return _this;
  }

  babelHelpers.createClass(EventInfoBar, [{
    key: "tick",
    value: function tick() {
      this.setState({
        now: Math.round(Date.now())
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.tickInterval = setInterval(this.tick, 1000);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearInterval(this.tickInterval);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.state.now > this.endTime) {
        clearInterval(this.tickInterval);
      }
    }
  }, {
    key: "timeUntil",
    value: function timeUntil(time) {
      var diff = time - this.state.now;
      if (diff < 0) return null;
      diff = Math.round(diff / 1000);
      var seconds = diff % 60;
      diff -= seconds;
      diff /= 60;
      var minutes = diff % 60;
      diff -= minutes;
      diff /= 60;
      var hours = diff % 24;
      diff -= hours;
      diff /= 24;
      var days = diff % 7;
      diff -= days;
      diff /= 7;
      var weeks = diff;
      if (weeks) return [[weeks, 'Week'], [days, 'Day'], [hours, 'Hour']].filter(function (v) {
        return v[0];
      });
      if (days) return [[days, 'Day'], [hours, 'Hour'], [minutes, 'Minute']].filter(function (v) {
        return v[0];
      });
      if (hours) return [[hours, 'Hour'], [minutes, 'Minute']];
      return [[minutes, 'Minute']];
    }
  }, {
    key: "render",
    value: function render() {
      var d = this.timeUntil(this.startTime);

      if (d) {
        return _react.default.createElement("div", {
          className: "stack small dark"
        }, _react.default.createElement("p", {
          className: "uppercase section-header"
        }, "Countdown to Event"), _react.default.createElement("div", {
          className: "countdown-container"
        }, d.map(function (item, index) {
          return _react.default.createElement("h2", {
            key: index
          }, _react.default.createElement("span", {
            className: "number"
          }, item[0]), " ", item[1], item[0] == 1 ? '' : 's');
        })));
      }

      d = this.timeUntil(this.endTime);

      if (d) {
        return _react.default.createElement("div", {
          className: "stack small dark"
        }, _react.default.createElement("p", {
          className: "uppercase section-header"
        }, "Countdown to Event"), _react.default.createElement("div", {
          className: "countdown-container"
        }, _react.default.createElement("h2", {
          className: "in-progress"
        }, "Event In Progress")));
      }

      return null;
    }
  }]);
  return EventInfoBar;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "startTime", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "endTime", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "tick", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "tick"), _class.prototype)), _class);
exports.default = EventInfoBar;